<template>
  <DefaultLayout
    :pageProps="{
      title: 'Reset password',
    }"
  >
    <template #content>
      <div class="text-center">
        We sent a reset password email to
        <b>{{ email }}</b>
        . Please check your email and click the reset password link to set your
        new password.
        <br />
        <br />
        Can't find the email in your inbox?
        <br />
        Please check your spam folder, or
        <router-link to="/forgot-password/send-email/">
          try again.
        </router-link>
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "../../layout/DefaultLayout.vue";

export default {
  name: "email-sent",
  components: { DefaultLayout },
  computed: {
    email() {
      return this.$route.query.email;
    },
  },
};
</script>
